import React from 'react'
import { inject, observer } from 'mobx-react'
import { CountriesPack } from './CountriesPack'
import { SearchCountries } from './SearchCountries'
import { StateType } from '../state'
import { Container } from './Container'
import { LulucfCaption } from '../../../components/LulucfCaption'

const margin = { top: 40, right: 10, bottom: 10, left: 10 }
const treemapRadius = 150

interface Props {
  state?: StateType
}
export const CirclesCountries: React.FC<Props> = inject('state')(
  observer(({ state }) => {
    const {
      countriesAlphabetical,
      selectedCountry,
      setSelectedCountry,
      selectedLulucf,
      hasLulucf,
    } = state.CountriesState

    const lulucfEmissions = selectedLulucf?.emission_mmt_co2

    return (
      <Container>
        <div
          className="flex flex-column flex-center"
          onClick={(event) => {
            if (event.target === event.currentTarget) setSelectedCountry(null)
          }}
        >
          <div className="ma3" style={{ width: treemapRadius * 2 }}>
            <SearchCountries
              options={countriesAlphabetical}
              value={selectedCountry}
              onChange={(option) => {
                setSelectedCountry(option)
              }}
            />
          </div>
          <CountriesPack margin={margin} radius={treemapRadius} />
          {/* {hasLulucf && <LulucfCaption classNames="ma2 tc lh-copy" emissions={lulucfEmissions} />} */}
        </div>
        <div className="-lulucf-caption" style={{ height: 48 }}>
          {hasLulucf && (
            <LulucfCaption classNames="lh-copy justify-center" emissions={lulucfEmissions} />
          )}
        </div>
      </Container>
    )
  })
)
